import React from 'react'
import { css } from 'emotion'

import UfmsLogo from '../../assets/mcti/logo_ufms.png'
import MtLogo from '../../assets/mcti/logo_mt.png'
import SecLogo from '../../assets/mcti/logo_sec.png'
import MctiLogo from '../../assets/mcti/logo_mcti.png'
import MecLogo from '../../assets/mcti/logo_mec.png'
import PucLogo from '../../assets/atrio/logo_puc.png'
import TvALogo from '../../assets/atrio/logo_tvanhanguera.png'
import AtrioLogo from '../../assets/atrio/logo_atrio.svg'

const imageSizeStyle = css`
  height: 100%;
  max-width: 100px;
  max-height: 50px;
  object-fit: contain;
`

const footerLogos = {
  '32': (
    <div
      css={css`
        width: 100%;
        display: grid;
        grid-template-columns: 8% 25% 15% 15% 30%;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        @media (max-width: 500px) {
          grid-template-columns: 8% 25% 15% 15% 30%;
        }
      `}
    >
      <img
        css={css`
          width: 40px;
          @media (max-width: 500px) {
            max-width: 100%;
            width: 35px;
          }
        `}
        alt='ufms logo'
        src={UfmsLogo}
      />
      <img
        css={css`
          width: 115px;
          @media (max-width: 500px) {
            max-width: 100%;
            width: 110px;
          }
        `}
        alt='logo secretária especial da cultura'
        src={SecLogo}
      />
      <img
        css={css`
          width: 68px;
          @media (max-width: 500px) {
            max-width: 100%;
            width: 65px;
          }
        `}
        alt='logo do ministério do turismo'
        src={MtLogo}
      />
      <img
        css={css`
          width: 70px;
          @media (max-width: 500px) {
            max-width: 100%;
            width: 60px;
          }
        `}
        alt='logo do ministério da educação'
        src={MecLogo}
      />
      <img
        css={css`
          width: 155px;
          @media (max-width: 500px) {
            max-width: 100%;
            margin-left: 5px;
            width: 140px;
          }
        `}
        alt='logo mcti'
        src={MctiLogo}
      />
    </div>
  ),
  '38': (
    <div
      css={css`
        width: 100%;
        display: flex;
        align-items: center;
        gap: 40px;
        @media (max-width: 400px) {
          gap: 25px;
        }
      `}
    >
      <img
        css={imageSizeStyle}
        alt='puc logo'
        src={PucLogo}
      />
      <img
        css={imageSizeStyle}
        alt='tv anhanguera logo'
        src={TvALogo}
      />
      <img
        css={imageSizeStyle}
        alt='atrio logo'
        src={AtrioLogo}
      />
    </div>
  )
}
const OrganizationsListFooter = ({ appId }) => {
  return (
    <>
      <div style={{ marginBottom: 10 }}>
        <span
          style={{
            color: '#878787',
            fontSize: 12
          }}
        >
          Organização:
        </span>
      </div>
      {footerLogos[appId]}
    </>
  )
}

export default OrganizationsListFooter
